<template>
    <div class="progressItem-box">
      <formTitle :title="`Grade ${newFormType}  Application`"></formTitle>
      <el-table :data="item.list">
        <el-table-column prop="stage" label="Stage" width="380">
          <template slot-scope="scope">
            <span>{{scope.row.stage | applicationStage}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="count" width="180"></el-table-column>
      </el-table>
    </div>
</template>

<script>
    import {applicationType} from '@/filters'
    import formTitle from '@/components/formTitle'
    export default {
      props: {
         item: {
           type: Object,
           default: () => {}
         }
      },
      computed:{
        newFormType(){
          return applicationType(this.item.formType)
        }
      },
      components:{
        formTitle
      },
    }
</script>

<style lang="scss" scoped>
.progressItem-box{
    border: 1px solid #3A91DD;
    margin-bottom: 20px;
   border-radius: 5px;
}
</style>